export default __webpack_public_path__ + "static/media/GBR.aac36550.svg";